import React from 'react'

const AdminChefOverview = () => {
    return (
        <h2>Overview</h2>
    )
}

export default AdminChefOverview
